module.exports = __webpack_public_path__ + "staticVue/img/home-bg.1b554e5b.jpg";